import React from 'react';
import './TermsOfService.css';

interface TermsOfServiceProps {
  onBack: () => void;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ onBack }) => {
  return (
    <div className="terms-of-service">
      <div className="terms-header">
        <button className="back-button" onClick={onBack}>
          ← Back
        </button>
        <h1>Terms of Service</h1>
      </div>
      
      <div className="terms-content">
        <div className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Remi AI, you accept and agree to be bound by the terms and 
            provision of this agreement. If you do not agree to abide by the above, please do not 
            use this service.
          </p>
        </div>

        <div className="terms-section">
          <h2>2. Description of Service</h2>
          <p>
            Remi AI provides a customer relationship management platform designed to help businesses 
            manage their founder and investor relationships, track activities, and organize data 
            effectively.
          </p>
        </div>

        <div className="terms-section">
          <h2>3. User Accounts</h2>
          <p>
            To access certain features of our service, you must register for an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your account information</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activities under your account</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>4. Acceptable Use</h2>
          <p>You agree not to use the service to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe on the rights of others</li>
            <li>Transmit harmful or malicious code</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Use the service for any unlawful purpose</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>5. Intellectual Property</h2>
          <p>
            The service and its original content, features, and functionality are owned by Remi AI 
            and are protected by international copyright, trademark, patent, trade secret, and other 
            intellectual property laws.
          </p>
        </div>

        <div className="terms-section">
          <h2>6. Privacy</h2>
          <p>
            Your privacy is important to us. Please review our Privacy Policy, which also governs 
            your use of the service, to understand our practices.
          </p>
        </div>

        <div className="terms-section">
          <h2>7. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, 
            for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
        </div>

        <div className="terms-section">
          <h2>8. Disclaimers</h2>
          <p>
            The service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, 
            expressed or implied, and hereby disclaim all other warranties including, without limitation, 
            implied warranties or conditions of merchantability, fitness for a particular purpose, 
            or non-infringement of intellectual property.
          </p>
        </div>

        <div className="terms-section">
          <h2>9. Limitation of Liability</h2>
          <p>
            In no event shall Remi AI, nor its directors, employees, partners, agents, suppliers, 
            or affiliates, be liable for any indirect, incidental, special, consequential, or punitive 
            damages, including without limitation, loss of profits, data, use, goodwill, or other 
            intangible losses, resulting from your use of the service.
          </p>
        </div>

        <div className="terms-section">
          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be interpreted and governed by the laws of [Your Jurisdiction], without 
            regard to its conflict of law provisions.
          </p>
        </div>

        <div className="terms-section">
          <h2>11. Changes to Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
            If a revision is material, we will try to provide at least 30 days notice prior to any 
            new terms taking effect.
          </p>
        </div>

        <div className="terms-section">
          <h2>12. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            Email: legal@itsremi.ai<br />
            Address: [Your Business Address]
          </p>
        </div>

        <div className="terms-footer">
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
